import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users/users.service';
import { JwtUser } from '../../models/user';
import { SecurityExpressions } from '../../utils/security-expressions';

@Component({
  selector: 'app-role-redirect',
  template: `
    <div class="flex justify-center items-center min-h-screen">
      <div class="text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
        <p class="mt-4 text-gray-600">Redirigiendo...</p>
      </div>
    </div>
  `,
  standalone: true
})
export class RoleRedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    this.redirectBasedOnRole();
  }

  private redirectBasedOnRole() {
    const user: JwtUser | null = this.usersService.getUser();
    
    if (!user) {
      // Si no hay usuario, redirigir al login
      this.router.navigate(['/']);
      return;
    }

    const userGroups: string[] = user['cognito:groups'] || [];
    
    // Verificar si el usuario tiene roles de Arcelor Mittal
    const hasArcelorMittalRole = SecurityExpressions.SITRACK_TECHNICAL_SUPPORT_AND_ALL_AM
      .some(role => userGroups.includes(role));
    
    // Verificar si el usuario tiene roles de Sitrack/Mas Seguros
    const hasSitrackRole = SecurityExpressions.SITRACK_ATC_AND_MAS_SEGUROS
      .some(role => userGroups.includes(role));
    
    // Lógica de redirección
    if (hasArcelorMittalRole && !hasSitrackRole) {
      // Solo roles de Arcelor Mittal -> redirigir a Arcelor Mittal
      this.router.navigate(['/arcelor-mittal']);
    } else if (hasSitrackRole) {
      // Roles de Sitrack (con o sin Arcelor Mittal) -> redirigir a solicitudes
      this.router.navigate(['/solicitudes']);
    } else {
      // Sin roles reconocidos -> redirigir a acceso denegado
      this.router.navigate(['/access-denied']);
    }
  }
}